module.exports = __webpack_public_path__ + "static/media/logo.25e2c656.png";